export type DisciplineData = {
    title: Title,
    unit: string,
    leaderboard: LeaderboardData[],
}

export enum DisciplineTitle {
    Ride = "Kolo",
    Run = "Běh",
    Walk = "Chůze",
    Swim = "Plavání",
    Fitness = "Fitness",
    Inline = "Bruslení",
}

const titleList = [DisciplineTitle.Ride, DisciplineTitle.Run, DisciplineTitle.Walk, DisciplineTitle.Swim, DisciplineTitle.Fitness, DisciplineTitle.Inline] as const;
export type Title = typeof titleList[number];

export const parseTitle = (text: unknown): Title | undefined => {
    const title = titleList.find((title) => title === text);
    if (title !== undefined) {
        return title;
    }
    return undefined;
}

/** Keep synchornized with backend app */
export enum ProblemCode {
    Code = "code",
    Scope = "scope",
    AlreadyExist = "already-exist",
    SaveUser = "save-user",
    GetUsers = "get-users",
    TokenRequest = "token-request",
    GetAthleteDetail = "get-athlete-detail",
    MissingId = "missing-id",
    UnknownId = "unknown-id",
    SaveRefreshToken = "save-refresh-token",
    RefreshToken = "refresh-token",
    GetUser = "get-user",
    GetUserIds = "get-user-ids",
}

/** Keep synchornized with backend app */
export enum SuccessCode {
    Added = "added",
}

export type UserResultData = {
    addedTimestamp: number | null,
    id: number,
    firstname: string,
    lastname: string,
    eBike: boolean,
    runKm: number,
    runMin: number,
    runElevationGain: number,
    walkKm: number,
    walkMin: number,
    walkElevationGain: number,
    rideKm: number,
    rideMin: number,
    rideElevationGain: number,
    inlineKm: number,
    inlineMin: number,
    inlineElevationGain: number,
    swimKm: number,
    swimMin: number,
    fitnessMin: number,
}

export type LocalResultsData = {
    timestamp: number,
    failedCount?: number,
    /** Guests are shown without a rank, their results still count to the donation */
    guests?: {
        [userId: string]: true,
    },
    data: {
        [userId: string]: {
            [month: number]: UserResultData,
        },
    },
}

/** Keep synchornized with backend app */
export type GetResultsResponse = {
    status: number,
    /** Year of the returned data */
    year: number,
    /** Years with results, newest first */
    years: number[],
    /** Null when the year has no results yet */
    data: LocalResultsData | null,
}

export type LeaderboardData = {
    id: number,
    addedTimestamp: number | null,
    firstname: string,
    lastname: string,
    score: number,
    km: number,
    min: number,
    elevationGain: number,
    eBike: boolean,
}
